import { ENotificationType } from "../interfaces";
import { useWatchBaseNotification, type IUseWatchBaseNotificationProps } from "./useWatchBaseNotification";

export type JobInProgressNotificationPayload = {
  id: number;
};

export const useWatchJobProgressNotifications = ({
  dissableSnackbarAlert = false,
  onNotificationArrived,
}: Omit<IUseWatchBaseNotificationProps<JobInProgressNotificationPayload>, "notificationTypes" | "buildSnackbarMessage"> = {}) =>
  useWatchBaseNotification<JobInProgressNotificationPayload>({
    notificationTypes: [
      ENotificationType.JobInProgress,
      ENotificationType.JobCompleted,
      ENotificationType.JobAccepted,
      ENotificationType.JobDeclined,
      ENotificationType.JobDeclined,
    ],
    dissableSnackbarAlert,
    onNotificationArrived,
    buildSnackbarMessage: (msg) => msg?.message ?? "",
  });
